import React from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";
import { Box } from "@mui/material";
import "./PieChart.scss";

const PiceChart = ({pieData}) => {
  return (
    <Box className="graphcard_container_sub">
      <Box>
        <div style={{ padding: "24px" }}>
          <h3 className="title">{pieData[0].message}</h3>
          <div >
            <PieChart
            className="pieChart"
              series={[
                {
                  data: pieData,
                  arcLabel: (item) => `${item.value}%`,
                },
              ]}
              width={340}
              height={340}
              sx={{
                [`& .${pieArcLabelClasses.root}`]: {
                  fill: "white",
                  fontSize: 12,
                },
                
              }}
            />
          </div>
          </div>
          <div className="piceChartLegendBox"
            
          >
            {pieData &&
              pieData?.map((item, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <div
                    style={{
                      width: "12px",
                      height: "12px",
                      borderRadius: "50%",
                      backgroundColor: item.color,
                    }}
                  ></div>
                  <span>{item.type}</span>
                </div>
              ))}
          </div>
       
      </Box>
    </Box>
  );
};

export default PiceChart;
